import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../environments/environment';
import { ApiResponse } from '../models/api-response';
import { map } from 'rxjs';
import { Playlist } from '../models/playlist';

@Injectable({
  providedIn: 'root'
})
export class PlaylistService {

  http = inject(HttpClient);

  getPlaylist(id : string) {
    
    const params = new HttpParams().set('id', id);

    return this.http
      .get<ApiResponse<Playlist[]>>(
        `${environment.apiUrl}/playlist`,
        {params}
      )
      .pipe(map(response => response.data[0]));

  }
  
  addPlaylist(id : string) {
    
    const params = new HttpParams().set('playlistId', id);

    return this.http
      .get<ApiResponse<[]>>(
        `${environment.apiUrl}/tasks/addplaylist`,
        {params}
      )
      .pipe(map(response => response.data));

  }

  
  updatePlaylist(id : string) {
    
    const params = new HttpParams().set('playlistId', id);

    return this.http
      .get<ApiResponse<Playlist[]>>(
        `${environment.apiUrl}/tasks/updateplaylist`,
        {params}
      )
      .pipe(map(response => response.data));

  }
}